import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip
} from 'chart.js';
import { GROWTH_AREA_COLORS } from '../utils/constants';

ChartJS.register(
  ArcElement,
  Tooltip
);

const GrowthAreaPieChart = ({ messages }) => {
  const growthAreaCounts = messages.reduce((acc, message) => {
    if (message && (message.growthArea || message.verse?.growthArea)) {
      const area = message.growthArea || message.verse?.growthArea;
      acc[area] = (acc[area] || 0) + 1;
    }
    return acc;
  }, {});

  if (Object.keys(growthAreaCounts).length === 0) {
    return null;
  }

  const data = {
    labels: Object.keys(growthAreaCounts),
    datasets: [
      {
        data: Object.values(growthAreaCounts),
        backgroundColor: Object.keys(growthAreaCounts).map(area => 
          GROWTH_AREA_COLORS[area]?.bg || 'rgba(200, 200, 200, 0.5)'
        ),
        borderColor: Object.keys(growthAreaCounts).map(area => 
          GROWTH_AREA_COLORS[area]?.border || 'rgba(200, 200, 200, 1)'
        ),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true,
        position: 'nearest',
        xAlign: 'left',
        yAlign: 'center',
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            return `${label}: ${value} verse${value !== 1 ? 's' : ''}`;
          }
        },
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        bodyFont: {
          size: 10
        },
        padding: 6,
        displayColors: false
      }
    },
    maintainAspectRatio: true
  };

  return (
    <div style={{ 
      width: '64px', 
      height: '64px',
      minWidth: '64px',
      minHeight: '64px',
      position: 'relative'
    }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default GrowthAreaPieChart;
